<template>
	<div class="card bg-base-100 shadow">
		<div class="card-body">
			<div class="flex flex-wrap items-center justify-between gap-3">
				<div class="flex items-center gap-3">
					<div class="card-title flex items-center gap-2 text-xl">{{ _tr('hubs.header.title') }}</div>
					<span class="badge badge-primary badge-soft" v-if="filteredCount">
						{{ filteredCount }}
					</span>
					<span class="badge badge-outline" v-if="totalModules">
						{{ _tr('hubs.header.totalModules', { count: totalModules }) }}
					</span>
					<span class="loading loading-spinner" v-if="isFetching"></span>
				</div>

				<div class="flex w-full items-center gap-2 sm:w-auto sm:justify-end">
					<label class="input input-sm w-full max-w-xs grow sm:max-w-xs">
						<Search class="h-4 w-4" />
						<input
							type="search"
							v-model="search"
							:placeholder="_tr('hubs.header.searchPlaceholder')"
							class="w-full"
							:aria-label="_tr('hubs.header.searchAria')" />
					</label>
					<select
						class="select select-sm min-w-[14rem]"
						v-model="selectedSort"
						:aria-label="_tr('hubs.header.sortAria')">
						<option v-for="opt in translatedSortOptions" :key="opt.value" :value="opt.value">
							{{ opt.label }}
						</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { computed } from 'vue'
	import { Search } from 'lucide-vue-next'
	import { useI18n } from 'vue-i18n'
	import { useHubs } from './_useHubs'
	import { _translations } from './_translations'

	const { search, selectedSort, sortOptions, filteredCount, totalModules, isFetching } = useHubs()
	const { t: _tr } = useI18n(_translations)

	const translatedSortOptions = computed(() =>
		sortOptions.map((opt) => ({
			...opt,
			label: _tr(`hubs.sort.${opt.value}`),
		})),
	)
</script>
